import { render, staticRenderFns } from "./XuPlanSelect.vue?vue&type=template&id=624fc002&scoped=true"
import script from "./XuPlanSelect.vue?vue&type=script&lang=js"
export * from "./XuPlanSelect.vue?vue&type=script&lang=js"
import style0 from "./XuPlanSelect.vue?vue&type=style&index=0&id=624fc002&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624fc002",
  null
  
)

export default component.exports